import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#32578b',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#cfd8dc',
      paper: '#FFFFFF',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
      disabled: 'rgba(0, 0, 0, 0.38)',
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
    h4: { fontWeight: 500, lineHeight: 1.6, letterSpacing: '0.15px' },
    h5: { fontWeight: 500, lineHeight: 1.6, letterSpacing: '0.15px' },
    h6: { fontWeight: 500, lineHeight: 1.6, letterSpacing: '0.15px' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          minHeight: 44,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          minWidth: 44,
          minHeight: 44,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          '@media (max-width: 600px)': {
            padding: '6px 8px',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#32578b',
          '& .MuiTableCell-head': {
            color: '#FFFFFF',
            fontWeight: 500,
          },
          '& .MuiTableSortLabel-root': {
            color: '#FFFFFF',
            '&:hover': { color: '#FFFFFF' },
            '&.Mui-active': {
              color: '#FFFFFF',
              '& .MuiTableSortLabel-icon': { color: '#FFFFFF' },
            },
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(even)': {
            backgroundColor: '#eceff1',
          },
        },
      },
    },
  },
});

export default theme;
